
var app = angular.module('directives.creditBanner', []);

require('./directives/creditBanner.js');
require('./stylesheets/creditBanner.scss');
require('./templates/index.html');

module.exports = app;




/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/creditBanner/index.js
 ** module id = 157
 ** module chunks = 1
 **/